import { render, staticRenderFns } from "./LastSopsTile.vue?vue&type=template&id=722f3fe4&scoped=true&"
import script from "./LastSopsTile.vue?vue&type=script&lang=ts&"
export * from "./LastSopsTile.vue?vue&type=script&lang=ts&"
import style0 from "./LastSopsTile.vue?vue&type=style&index=0&id=722f3fe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f3fe4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VCardText,VCardTitle,VChip})
